// capacitor
import {
    Plugins
} from "@capacitor/core";
// firebase
import db from "@/firebase/init";
// store
import store from "@/utils/store.js";

export default function presentAlert(params) {
    const alert = document.createElement("ion-alert");
    alert.header = params.header;
    alert.subHeader = params.subHeader;
    alert.message = params.message;
    alert.buttons = [{
        text: "Não",
        role: "cancel"
    }, {
        text: "Sim",
        handler: async () => {
            if (params.platform !== "web") {
                store.state.profile.data.reviewed = new Date();
                db.collection("users").doc(params.profileId).update({
                    reviewed: new Date()
                });
                Plugins.CapacitorRateApp.requestReview();
            }
        }
    }];

    document.body.appendChild(alert);
    return alert.present();
};